const ChannelTypeCategory = {
  online: 'online',
  offline: 'offline',
};

export default ChannelTypeCategory;
